export { default as GenerateTag } from './page'


// WEBPACK FOOTER //
// ./src/pages/generateTag/index.js